import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useBlogDetails } from './hooks/BlogDetails.hook';
import BlogDetailsView from './views/BlogDetailsView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const BlogDetailsController = () => {
  const { id } = useParams();
  const { isLoading, blogsData: blogDetail } = useBlogDetails(id);

  const [showDetail, setShowDetail] = useState(false);

  if (!id || isLoading) {
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <BlogDetailsView blogDetail={blogDetail} setShowDetail={setShowDetail} />
  );
};

export default BlogDetailsController;
